import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const BreadcrumbTitleContext = createContext({
  titles: {},
  setBreadcrumbTitle: () => {},
  clearBreadcrumbTitle: () => {},
});

/**
 * عناوین پویا برای breadcrumb (نام جلسه، سازمان، اتاق و …).
 */
export function BreadcrumbTitleProvider({ children }) {
  const [titles, setTitles] = useState({});

  const setBreadcrumbTitle = useCallback((key, label) => {
    if (!key) return;
    setTitles((prev) => {
      if (prev[key] === label) return prev;
      return { ...prev, [key]: label };
    });
  }, []);

  const clearBreadcrumbTitle = useCallback((key) => {
    if (!key) return;
    setTitles((prev) => {
      if (!(key in prev)) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ titles, setBreadcrumbTitle, clearBreadcrumbTitle }),
    [titles, setBreadcrumbTitle, clearBreadcrumbTitle],
  );

  return (
    <BreadcrumbTitleContext.Provider value={value}>
      {children}
    </BreadcrumbTitleContext.Provider>
  );
}

export function useBreadcrumbTitles() {
  return useContext(BreadcrumbTitleContext);
}

/** ثبت عنوان پویا تا وقتی کامپوننت mount است */
export function useBreadcrumbTitle(key, label) {
  const { setBreadcrumbTitle, clearBreadcrumbTitle } = useBreadcrumbTitles();
  const resolved = label || undefined;

  useEffect(() => {
    if (!key || !resolved) return undefined;
    setBreadcrumbTitle(key, resolved);
    return () => clearBreadcrumbTitle(key);
  }, [key, resolved, setBreadcrumbTitle, clearBreadcrumbTitle]);
}
